import { useState, useEffect, useCallback, useRef } from "react"
import { useParams } from "react-router"
import { useLocation } from 'react-router-dom'

import Grid from '@material-ui/core/Grid'

import Breadcrumbs from '@base/Breadcrumbs'
import Title from '@base/Title'
import Toast from '@base/Toast'
import Subtitle from "@base/Subtitle"

import CartoesTableView from "@pages/Escola/Cartoes/componentes/CartoesTableView"

import { ProcessoResolver } from "@helpers/ProcessoHelper"

import EscolaService from "@services/EscolaService"

export const ListagemCartoesPorEscola = (props) => {
	const toastRef = useRef(null)

	const [nomeEscola, setNomeEscola] = useState("");

	const params = useParams();
	const processo = ProcessoResolver(params.processo);

	const location = useLocation();

	const carregarDados = useCallback(() => {
		EscolaService.listarPorCodigoInepOuEticket(processo.id, params.escola).then(escola => {
			setNomeEscola(escola.data.nome);
		});
	}, [processo.id, params.escola]);

	useEffect(() => carregarDados(), [carregarDados]);

	const pageName = 'Cartões';
	const breadcrumbs = [
		{
			path: `/${processo.id}/escolas`,
			name: "Escolas"
		},
		{
			path: `/${processo.id}/escola/${params.escola}`,
			name: nomeEscola
		}
	];

	return (
		<>
			<Toast ref={toastRef} />
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Breadcrumbs links={breadcrumbs} active={pageName} />
				</Grid>
			</Grid>

			<br />
			<Title>{nomeEscola}</Title>
			<Subtitle>Listagem de Cartões</Subtitle>
			<br />

			<CartoesTableView nivel={location.state !== undefined ? location.state.nivel : ""} escola={params.escola} processo={processo.id} />
		</>
	);
}

export default ListagemCartoesPorEscola;
